/* NaskiCo catalogue v2 (catalogue upgrade 2026-10-24). Native Shopify filters via the Section Rendering API. */
(function(){
  var root=document.querySelector('[data-nc2]'); if(!root) return;
  var SECTION='naskico-catalog-v2-results';
  var $=function(s,c){return (c||document).querySelector(s)}, $$=function(s,c){return [].slice.call((c||document).querySelectorAll(s))};
  var drawer=$('[data-nc2-drawer]'), form=$('[data-nc2-form]'), facetsHost=$('[data-nc2-facets-host]'), chipsHost=$('[data-nc2-chips-host]');
  var res=$('[data-nc2-res]'), sortSel=$('[data-nc2-sort]'), sortIn=$('[data-nc2-sort-input]'), bar=$('[data-nc2-bar]');
  var mqD=window.matchMedia('(min-width: 750px)'), hover=window.matchMedia('(hover: hover) and (pointer: fine)');
  var truth=null; try{truth=JSON.parse(($('#nc2-truth')||{}).textContent||'{}')}catch(e){truth={}}
  var watchNode=null, busy=0, ctl=null;

  /* ---------- mount the server-rendered pieces into the bar and drawer ---------- */
  function mount(scope){
    var f=$('#nc2-facets',scope), c=$('#nc2-chips',scope), d=$('#nc2-data',res);
    if(f){facetsHost.innerHTML='';facetsHost.appendChild(f)}
    if(c){chipsHost.innerHTML='';chipsHost.appendChild(c)}
    if(d){
      var n=d.getAttribute('data-count'), a=+d.getAttribute('data-active')||0;
      $$('[data-nc2-count]').forEach(function(el){el.textContent=n});
      var b=$('[data-nc2-active]'); b.hidden=!a; b.textContent=a;
      root.classList.toggle('has-filters',a>0);
    }
    refs(); 
  }
  function refs(){
    $$('.nc2-card [data-ref]:empty').forEach(function(el){
      var card=el.closest('.nc2-card'), t=truth[card.getAttribute('data-handle')];
      if(t&&t.r){el.textContent=' · '+t.r}
    });
  }

  /* ---------- fetch + swap ---------- */
  function cleanUrl(u){var x=new URL(u,location.origin);x.searchParams.delete('section_id');x.searchParams.delete('page');return x}
  function fetchSection(u){
    var x=new URL(u,location.origin); x.searchParams.set('section_id',SECTION);
    if(ctl) ctl.abort(); ctl=('AbortController' in window)?new AbortController():null;
    return fetch(x.toString(),{credentials:'same-origin',signal:ctl&&ctl.signal}).then(function(r){if(!r.ok) throw new Error(r.status);return r.text()})
      .then(function(t){var d=document.createElement('div');d.innerHTML=t;return d});
  }
  function load(u,push){
    root.classList.add('is-loading'); busy++;
    var x=cleanUrl(u);
    return fetchSection(x.toString()).then(function(d){
      var g=$('#nc2-grid',d), old=$('#nc2-grid',res);
      if(watchNode&&g){var nw=$('[data-nc2-watch]',g); if(nw) nw.replaceWith(watchNode)}
      ['#nc2-grid','#nc2-more','#nc2-empty','#nc2-data'].forEach(function(id){var n=$(id,d), o=$(id,res); if(n&&o) o.replaceWith(n)});
      mount(d);
      if(push) history.pushState({nc2:1},'',x.pathname+x.search);
      var s=$('#nc2-data',res); if(s&&sortSel){sortSel.value=s.getAttribute('data-sort')||sortSel.value; sortIn.value=sortSel.value}
      wireCards(); placeWatch(); if(root.getAttribute('data-view')==='alt')preloadAltImages(); if(window.nskSyncSaved)window.nskSyncSaved();
    }).catch(function(e){ if(e&&e.name==='AbortError') return; location.href=x.toString(); })
      .then(function(){ if(--busy<=0){busy=0;root.classList.remove('is-loading')} });
  }
  function formUrl(){
    var fd=new FormData(form), p=new URLSearchParams();
    fd.forEach(function(v,k){ if(v!=='' && v!=null) p.append(k,v) });
    return root.getAttribute('data-url')+'?'+p.toString();
  }

  /* ---------- drawer ---------- */
  var lastFocus=null;
  function openDrawer(){lastFocus=document.activeElement;drawer.hidden=false;requestAnimationFrame(function(){drawer.classList.add('on')});
    document.documentElement.classList.add('nc2-lock');$('[data-nc2-open]').setAttribute('aria-expanded','true');
    var x=$('.nc2-drawer__x',drawer); x&&x.focus()}
  function closeDrawer(){drawer.classList.remove('on');document.documentElement.classList.remove('nc2-lock');$('[data-nc2-open]').setAttribute('aria-expanded','false');
    setTimeout(function(){drawer.hidden=true},260); lastFocus&&lastFocus.focus&&lastFocus.focus()}
  $('[data-nc2-open]').addEventListener('click',openDrawer);
  $$('[data-nc2-close]').forEach(function(b){b.addEventListener('click',closeDrawer)});
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!drawer.hidden) closeDrawer() });

  var t=null;
  form.addEventListener('change',function(e){
    clearTimeout(t); var isNum=e.target&&e.target.type==='number';
    t=setTimeout(function(){load(formUrl(),true)}, isNum?600:60);
  });
  form.addEventListener('input',function(e){ if(e.target&&e.target.type==='number'){clearTimeout(t);t=setTimeout(function(){load(formUrl(),true)},800)} });
  form.addEventListener('submit',function(e){e.preventDefault(); clearTimeout(t); var p=load(formUrl(),true); p.then(closeDrawer)});

  /* chips, clear all, pager links */
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[data-nc2-link]'); if(!a||!root.contains(a)) return;
    if(e.metaKey||e.ctrlKey||e.shiftKey) return;
    e.preventDefault(); load(a.href,true);
  });

  /* sort */
  if(sortSel) sortSel.addEventListener('change',function(){ sortIn.value=sortSel.value; load(formUrl(),true) });

  /* load more: append the next page */
  res.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('[data-nc2-more]'); if(!a) return;
    e.preventDefault(); a.classList.add('is-busy'); a.textContent='Loading';
    fetchSection(a.href).then(function(d){
      var g=$('#nc2-grid',d), grid=$('#nc2-grid',res);
      if(g){ $$('.nc2-card',g).forEach(function(c){grid.appendChild(c)}); grid.setAttribute('data-page',g.getAttribute('data-page')) }
      var m=$('#nc2-more',d), om=$('#nc2-more',res); if(m&&om) om.replaceWith(m);
      wireCards(); refs(); if(root.getAttribute('data-view')==='alt')preloadAltImages(); if(window.nskSyncSaved)window.nskSyncSaved();
    }).catch(function(){ location.href=a.href });
  });

  window.addEventListener('popstate',function(){ load(location.href,false) });

  /* ---------- grid density ---------- */
  function getCols(){ try{return mqD.matches?(localStorage.getItem('nc2-cols-d')||''):(localStorage.getItem('nc2-cols-m')||'')}catch(e){return ''} }
  function applyCols(){
    var c=getCols(); if(mqD.matches){ if(!/^[2345]$/.test(c)) c=window.innerWidth>=1840?'5':(window.innerWidth>=1180?'4':'3'); root.style.setProperty('--nc2-cols-d',c); root.style.setProperty('--nc2-cols-t',c) }
    else { if(!/^[12]$/.test(c)) c='2'; root.style.setProperty('--nc2-cols-m',c) }
    root.setAttribute('data-cols',c); placeWatch();
    $$('[data-nc2-cols]').forEach(function(b){ var on=b.getAttribute('data-nc2-cols')===c; b.classList.toggle('on',on); b.setAttribute('aria-pressed',on?'true':'false') });
  }
  $$('[data-nc2-cols]').forEach(function(b){ b.addEventListener('click',function(){ try{localStorage.setItem(mqD.matches?'nc2-cols-d':'nc2-cols-m',b.getAttribute('data-nc2-cols'))}catch(e){} applyCols() }) });
  (mqD.addEventListener?mqD.addEventListener('change',applyCols):mqD.addListener(applyCols));

  /* ---------- cards: second image on hover, colour swatches ---------- */
  function wireCards(){
    $$('.nc2-card__img',res).forEach(function(im){im.classList.add('nsk-ld');im.decoding='async'});
    $$('.nc2-card__media[data-alt]:not([data-w])').forEach(function(m){
      m.setAttribute('data-w','1'); if(!hover.matches) return;
      m.closest('.nc2-card').addEventListener('pointerenter',function(){
        if(m.querySelector('.nc2-card__img2')) return;
        var first=m.querySelector('.nc2-card__img'), i=new Image();
        i.className='nc2-card__img2'; i.alt=''; i.decoding='async';
        i.onload=function(){m.classList.add('has-alt')};
        i.sizes=first?first.getAttribute('sizes'):'50vw'; i.srcset=m.getAttribute('data-alt-srcset'); i.src=m.getAttribute('data-alt');
        if(i.complete)m.classList.add('has-alt'); m.appendChild(i);
      },{once:false});
    });
    $$('.nc2-sw:not([data-w])').forEach(function(ul){
      ul.setAttribute('data-w','1');
      ul.addEventListener('click',function(e){
        var b=e.target.closest('.nc2-sw__b'); if(!b) return;
        $$('.nc2-sw__b',ul).forEach(function(x){x.classList.toggle('on',x===b)});
        var src=b.getAttribute('data-img'), img=b.closest('.nc2-card').querySelector('.nc2-card__img'); if(!src||!img) return;
        img.removeAttribute('srcset'); img.src=src;
      });
    });
  }

  /* ---------- sticky bar offset under the site header (O(1) lookup) ---------- */
  function topOffset(){
    var hdr=document.getElementById('nnav')||document.querySelector('.nskh, header.nav');
    var h=0;
    if(hdr){
      var r=hdr.getBoundingClientRect();
      if(r.top<=1&&r.bottom>0&&r.height<220) h=r.bottom;
    }
    root.style.setProperty('--nc2-top',Math.round(h)+'px');
  }

  /* Watch tile sits after 7 cards (fills the 8th slot at 4-up), or after 8 on 2-up mobile where it spans the row. */
  function placeWatch(){
    var w=$('[data-nc2-watch]',res), grid=$('#nc2-grid',res); if(!w||!grid) return;
    var dc=root.getAttribute('data-cols'); var n=(!mqD.matches && dc==='2')?8:(dc==='5'?9:7);
    var cards=$$('.nc2-card',grid); if(cards.length<n) return;
    var after=cards[n-1]; if(after.nextElementSibling!==w) after.after(w);
  }

  /* ---------- Watch tile success state after the /contact round trip ---------- */
  function watchState(){
    var w=$('[data-nc2-watch]'); if(!w) return; watchNode=w;
    var u=location.href; if(/customer_posted=true/.test(u)){ $('.nc2-watch__form',w).hidden=true; $('.nc2-watch__ok',w).hidden=false }
  }

  
  /* ---------- U6: Artwork View vs Alt / Worn View global toggle + U5 mobile Quick-Add toggle ---------- */
  var altIo = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(en){
      if(!en.isIntersecting) return;
      var m = en.target; altIo.unobserve(m);
      if(m.querySelector('.nc2-card__img2')) return;
      var first=m.querySelector('.nc2-card__img'), i=new Image();
      i.className='nc2-card__img2'; i.alt=''; i.decoding='async'; i.loading='lazy';
      i.onload=function(){m.classList.add('has-alt')};
      i.sizes=first?first.getAttribute('sizes'):'45vw'; i.srcset=m.getAttribute('data-alt-srcset')||''; i.src=m.getAttribute('data-alt');
      if(i.complete)m.classList.add('has-alt'); m.appendChild(i);
    });
  }, {rootMargin: '240px 0px'}) : null;
  function preloadAltImages(){
    $$('.nc2-card__media[data-alt]').forEach(function(m){
      if(m.querySelector('.nc2-card__img2')) return;
      if(altIo) altIo.observe(m);
    });
  }
  function setViewMode(mode){
    var m = mode === 'alt' ? 'alt' : 'art';
    root.setAttribute('data-view', m);
    if (m === 'alt') preloadAltImages();
    $$('[data-nc2-view]').forEach(function(b){
      var on = b.getAttribute('data-nc2-view') === m;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  $$('[data-nc2-view]').forEach(function(b){
    b.addEventListener('click', function(){ setViewMode(b.getAttribute('data-nc2-view')); });
  });
  root.addEventListener('click', function(e){
    var qaTog = e.target.closest && e.target.closest('[data-nc2-qa-toggle]');
    if (qaTog) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = qaTog.closest('[data-nc2-qa]');
      if (wrap) {
        var open = wrap.classList.toggle('is-open');
        qaTog.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  root.classList.add('js-nc2'); mount(res); applyCols(); wireCards(); watchState(); topOffset();
  window.addEventListener('resize',function(){clearTimeout(window.__nc2r);window.__nc2r=setTimeout(topOffset,150)});
  window.addEventListener('scroll',function(){ if(!window.__nc2t){window.__nc2t=1;setTimeout(function(){topOffset();window.__nc2t=0},400)} },{passive:true});
})();
